import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { BaseEntity, BaseState } from "../../base/entities/BaseEntities";
import { BasePageComponent } from "../../base/component/BasePageComponent";
import { ResourcesService } from './resources.service';
import { MessageBoxOptions } from '@m4u-angular/base/classes/BaseClasses';
import { EnumMessageBoxTypes } from './sysenums.enum';
import { FrameworkService } from './framework.service';
import { SysEventsService } from './sysevents.service';
import { BasePageCRUDComponent } from '@m4u-angular/base/component/BasePageCRUDComponent';
import {UiService} from '@core/framework/ui.service';
import { of } from 'rxjs';

@Injectable()
export class ConfirmCancelGuard implements CanDeactivate<BasePageComponent<BaseEntity, BaseState>> {
    constructor(private framework: FrameworkService, private resourceService: ResourcesService, private sysEvents: SysEventsService, private ui: UiService) {

    }
    canDeactivate(page: BasePageComponent<BaseEntity, BaseState>) {
        if (page instanceof BasePageCRUDComponent && !page.OnIsDirtyDisabled() && page.IsDirty) {
            const options = new MessageBoxOptions(EnumMessageBoxTypes.YesNo, this.resourceService.RC('titleLeavePageConfirmation'));
            this.ui.OpenMessageBox(options);
            return this.sysEvents.CloseMessageBoxSubject;
        }
        return of(true);
    }
}
